import Thicc from './Spinner.vue';
import Loading from './Loading.vue';
export const Spinners = {
  Thicc,
  Loading,
};
